import { JSX } from "react";
import { ColumnConfig, wafflesKeyColumnName } from "@app/shared/waffles";
import { Waffles } from "@app/shared/waffles/Waffles";
import { TinInformationModel } from "@app/projects/servicing-provider/providerAffiliation";


interface TinInformationAccordionProps {
  tins: TinInformationModel[];
}

interface TinInformationTableData {
  [wafflesKeyColumnName]: string;
  name: string;
  tin: string;
}

const TinInformationAccordion = (props: TinInformationAccordionProps): JSX.Element => {
  const tins: TinInformationTableData[] = props.tins.map((tin, index) => {
      return {
        key: index.toString(),
        name: tin.name,
        tin: tin.tin
      }
    })

  const columnConfig: ColumnConfig = ({    
    name: {
      displayText: "TIN Name",
      noResize: true,
      noSort: true,
      sizeContentToFit: true,
      sortOrder: 2,
      testId: 'tinName-affiliation'
    },
    tin: {
      displayText: "Identifier (TIN)",
      noResize: true,
      noSort: true,
      sizeContentToFit: true,
      sortOrder: 1,
      testId: 'tinId-affiliation'
    },
  });

  return (
    <>
        <Waffles<TinInformationTableData>
          columns={columnConfig}
          data={tins}
          testId="provider-affiliation-tin-information-waffles"
          fullWidth={true}
        />   
    </>
  )
}

export default TinInformationAccordion;
